const CUSTOMER_SUCCESS_STATISTICS = {
  CUSTOMER_SUCCESS_HEADER_TITLE: 'Customer satisfaction',
  CUSTOMER_SUCCESS_HEADER_DESC:
    'You can see the aggregate statistics related to the points given by the customers in this section.',
  CUSTOMER_SUCCESS_STAT_CARD_AVERAGE_SCORE_TITLE: 'Average scores',
  CUSTOMER_SUCCESS_STAT_CARD_AVERAGE_SCORE_COUNT_TITLE: 'Score (1 to 4)',
  CUSTOMER_SUCCESS_STAT_CARD_SUBMITED_SCORES_TITLE: 'Registered points',
  CUSTOMER_SUCCESS_STAT_CARD_SUBMITED_SCORES_COUNT_TITLE: 'Registered points',
  CUSTOMER_SUCCESS_STAT_CARD_SATISFACTION_SCORE_TITLE:
    'Customer satisfaction (%)',
  CUSTOMER_SUCCESS_STAT_CARD_SATISFACTION_SCORE_COUNT_TITLE: 'Satisfaction (%)',
  CUSTOMER_SUCCESS_STAT_CARD_HAPPY_CUSTOMERS_TITLE:
    'Percentage of happy customers (😍)',
  CUSTOMER_SUCCESS_STAT_CARD_HAPPY_CUSTOMERS_COUNT_TITLE: 'Customers (%)',
  CUSTOMER_SUCCESS_STAT_CARD_ANGRY_CUSTOMERS_TITLE:
    'Percentage of angry customers (😡)',
  CUSTOMER_SUCCESS_STAT_CARD_ANGRY_CUSTOMERS_COUNT_TITLE: 'Customers (%)',
  CUSTOMER_SUCCESS_CHART_HEADER_TITLE: 'Operators scores',
  CUSTOMER_SUCCESS_CHART_NO_DATA: 'no data to display',
  CUSTOMER_SUCCESS_CHART_RATE_1_LEGEND: '(score 1)😍',
  CUSTOMER_SUCCESS_CHART_RATE_2_LEGEND: '(score 2)😀',
  CUSTOMER_SUCCESS_CHART_RATE_3_LEGEND: '(score 3)😔',
  CUSTOMER_SUCCESS_CHART_RATE_4_LEGEND: '(score 4)😡',
  CUSTOMER_SUCCESS_EXPORT_BTN_LABEL: 'CSV export',
};

export default CUSTOMER_SUCCESS_STATISTICS;
